module.exports = __webpack_public_path__ + "img/nativePay (1).c8e300dd.png";